import { z } from 'zod';

const SlidingWindowRateLimitSchema = z.object({
  windowSeconds: z.number(),
  max: z.number(),
  groupByKey: z.string().optional().nullable(),
});

export type SlidingWindowRateLimit = z.infer<
  typeof SlidingWindowRateLimitSchema
>;

export const RateLimitSchema = z.object({
  slidingWindows: z.array(SlidingWindowRateLimitSchema).nullable().optional(),
});

export type RateLimit = z.infer<typeof RateLimitSchema>;
